export function libraryLinkName(user) {
  return `${user.accountName} Library`;
}

export const LIBRARY_ROUTE = {
  BASE: '/library',
  SEARCH: '/library/search',
  SEARCH_LIBRARY: (libraryId: number | string) => `/library/search/${libraryId}`,
};
